import { GoogleIcon, TikTokIcon } from '../Icons';
import ClusterIcon from '../ClusterIcon';
import OverviewCardWrapper from './OverviewCardWrapper';
import { TableRowBody } from '../DataVis/DataTable/styledComponents';
import { getScoreColor } from 'utils/helpers';
import styled from 'styled-components';

const ClusterTag = styled.span`
    font-weight: ${({ theme }) => theme.fontBold};
    color: ${({ score }) => getScoreColor(score)};
    font-size: ${({ theme }) => theme.fontSize_sm};
    line-height: ${({ theme }) => theme.fontSize_base};
    text-transform: capitalize;
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
`;

const OverviewCardGoogleIcon = styled(GoogleIcon)`
    color: ${({ theme }) => theme.google_blue};
    ${OverviewCardWrapper}:not(:hover):not(:focus-visible) & {
        color: ${({ theme }) => theme.gray_600};
    }
`;

const OverviewCardTikTokIcon = styled(TikTokIcon)`
    color: ${({ theme }) => theme.tiktok_pink};
    ${OverviewCardWrapper}:not(:hover):not(:focus-visible) & {
        color: ${({ theme }) => theme.gray_600};
    }
`;

export const CardStatIcon = styled.span`
    font-size: ${({ theme }) => theme.space_9}px;
    line-height: ${({ theme }) => theme.space_10}px;
    color: ${({ score, metricLabel }) =>
        getScoreColor(score, false, metricLabel)};

    ${OverviewCardWrapper}:not(:hover):not(:focus-visible) & {
        color: ${({ theme }) => theme.gray_600};
    }
    ${TableRowBody}:not(:hover):not(:focus-visible) & {
        color: ${({ theme }) => theme.gray_600};
    }
`;

export function getClusterScore(cluster) {
    return cluster && cluster.includes('ris')
        ? 10
        : cluster && cluster.includes('flat')
          ? 5
          : cluster
            ? 1
            : null;
}

function ClusterStat({ dataSource, cluster, showIcon = true, ...props }) {
    const score = getClusterScore(cluster);

    return (
        <ClusterTag score={score} {...props}>
            {dataSource === 'GOOGLE' && showIcon ? (
                <OverviewCardGoogleIcon />
            ) : null}
            {dataSource === 'TIKTOK' && showIcon ? (
                <OverviewCardTikTokIcon />
            ) : null}
            {!dataSource && showIcon ? (
                <ClusterIcon css="vertical-align: middle;" cluster={cluster} />
            ) : null}
            {cluster || '—'}
        </ClusterTag>
    );
}

export default ClusterStat;
